<template>
	<v-list-item-action v-bind="$attrs" v-on="$listeners">
		<slot></slot>
	</v-list-item-action>
</template>

<script>
export default {
	name: 'KListItemAction'
};
</script>